import { render, staticRenderFns } from "./dealWasteDetail.vue?vue&type=template&id=2a913ad7&scoped=true"
import script from "./dealWasteDetail.vue?vue&type=script&lang=js"
export * from "./dealWasteDetail.vue?vue&type=script&lang=js"
import style0 from "./dealWasteDetail.vue?vue&type=style&index=0&id=2a913ad7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a913ad7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a913ad7')) {
      api.createRecord('2a913ad7', component.options)
    } else {
      api.reload('2a913ad7', component.options)
    }
    module.hot.accept("./dealWasteDetail.vue?vue&type=template&id=2a913ad7&scoped=true", function () {
      api.rerender('2a913ad7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cooperationMall/newCooperationMall/detail/dealWasteDetail.vue"
export default component.exports